import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getAppTitle } from '../../utils/titles'
import { requestPopularServices, getPopularServices } from '../../ducks/addons'
import { requestApp, getApp } from '../../ducks/apps'
import Page from '../Shared/Page'
import List from './List'
import DetailsModal from './DetailsModal'
import './Addons.css'

class Addons extends Component {
  getBaseURL = () => {
    const { match } = this.props
    const { appId } = match.params

    return `/apps/${appId}/addons`
  }

  componentDidMount() {
    const { requestApp, requestPopularServices, match } = this.props
    const { appId } = match.params

    requestApp(appId)
    requestPopularServices()
  }

  render() {
    const { app, services, match } = this.props
    const { serviceId } = match.params

    return (
      <Page
        className="addons-page"
        title={getAppTitle(app, 'Addons')}
        modalContent={serviceId && <DetailsModal serviceId={serviceId} />}
        modalProps={{ className: 'addons-modal' }}
        baseURL={this.getBaseURL()}
      >
        <h1>Addons</h1>
        <div className="addons-page-main">
          <div className="addons-page-content">
            <List list={services} title="Popular Addons" />
          </div>
          <div className="addons-page-sidebar">
            <h2>What Are Addons?</h2>
            <p>
              {`Addons give your app superpowers—things like accepting payments,
                sending emails, and much more. Addons add additional Actions,
                Data Connections, and Components. To find out more, click on
                an Addon to the left! `}
              <span role="img" aria-label="Pointing Left">
                👈
              </span>
            </p>
          </div>
        </div>
      </Page>
    )
  }
}

const mapStateToProps = (state, { match }) => ({
  app: getApp(state, match.params.appId),
  services: getPopularServices(state),
})

export default connect(mapStateToProps, { requestApp, requestPopularServices })(
  Addons
)
